import { render, staticRenderFns } from "./UsageCard.vue?vue&type=template&id=52862db0&scoped=true&"
import script from "./UsageCard.vue?vue&type=script&lang=js&"
export * from "./UsageCard.vue?vue&type=script&lang=js&"
import style0 from "./UsageCard.vue?vue&type=style&index=0&id=52862db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52862db0",
  null
  
)

export default component.exports